import * as React from 'react';

export type ProfileNoticeProps = {
	visible: boolean;
	text: string;
};

const uiStates = {
	visible: 'state-o-profile__notice--visible',
};

export const ProfileNotice = ({ visible = false, text }: ProfileNoticeProps) => {
	return (
		<div className={`o-profile__notice ${visible ? uiStates.visible : ''}`}>
			<span className="o-profile__notice-text">{text}</span>
		</div>
	);
};

ProfileNotice.displayName = 'ProfileNotice';

export default ProfileNotice;
